export enum CaseType {

    New = '1',
    Remake = '2',
    Adjustment = '3',
    Continue = '4'
}